import { Pipe, PipeTransform } from '@angular/core';
import { DetailFormDataModel } from 'src/app/config/model/detail-form-data.model';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'detailViewTitle',
    standalone: false
})
export class DetailViewTitlePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(detailFormDataModel: DetailFormDataModel): Observable<string> {
    if (detailFormDataModel) {
      const featureTitle = this.displayFeatureTitle(detailFormDataModel);
      let returnVal: Observable<string> = of(featureTitle);
      if (detailFormDataModel.detailViewTitle) {
        returnVal = this.translate.get(detailFormDataModel.detailViewTitle).pipe(
          map(title => {
            return featureTitle ? `${title}: ${featureTitle}` : title;
          })
        );
      }
      return returnVal;
    }
  }

  private displayFeatureTitle(detailFormDataModel: DetailFormDataModel): string {
    const attributetitle = detailFormDataModel.detailViewAttributeTitle;
    let displayAttribute = detailFormDataModel.selectedFeature.attributes[attributetitle];
    if (!displayAttribute) displayAttribute = '';
    return displayAttribute;
  }
}
